import React from 'react';
import { Routes, Route } from 'react-router-dom';

import GrilldBurgerBucks from './burger-bucks';
import GrilldRelish from './relish';

import './styles.css';

export default function Grilld() {
  return (
    <Routes>
      <Route path="/burger-bucks" element={<GrilldBurgerBucks />} />
      <Route path="/relish" element={<GrilldRelish />} />
    </Routes>
  );
}
